import React from 'react';
import { User } from '../../services/userService'; // Import the User type

interface SkillsExpertiseProps {
    // Expecting skills as string[] based on current User type
    skills: string[]; 
}

const SkillsExpertise: React.FC<SkillsExpertiseProps> = ({ skills }) => {
    const hasSkills = skills && skills.length > 0;

    return (
        <div className="card border-0 shadow-sm mb-4">
            <div className="card-header bg-white py-3">
                <h5 className="mb-0 fw-bold">Skills & Expertise</h5>
            </div>
            <div className="card-body p-4">
                <div className="d-flex flex-wrap gap-2">
                    {hasSkills ? (
                        // Map directly over the string array
                        skills.map((skill, index) => (
                            <div key={index} className="badge bg-light text-dark border p-2">{skill}</div>
                        ))
                    ) : (
                        <p className="text-muted mb-0">No skills added yet. Add your skills to help others find you for collaboration opportunities.</p>
                    )}
                </div>
            </div>
        </div>
    );
};

export default SkillsExpertise; 